import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['outcome'];

  toggleOutcomeClass(e) {
    this.outcomeTargets.forEach((element) => {
      element.classList.remove('amba-notes-form-outcome--active');
    });

    e.target.classList.toggle('amba-notes-form-outcome--active');
  }
}
